import { NavLink, useMatch } from "react-router-dom";
import { summaryBySlug } from "../../content/lookup.ts";
import { getTrainer } from "../../trainer/session.ts";
import { useTrainer } from "../trainer/useTrainer.ts";

/** Away from the board, a way back to the game in progress. */
export function ResumeLink() {
  const onTrainer = useMatch("/train/:courseId");
  const snapshot = useTrainer();
  const course = snapshot.slug ? summaryBySlug(snapshot.slug) : null;
  if (onTrainer || !course || !getTrainer().canResume(course.slug)) return null;
  return (
    <NavLink
      className="nav-btn nav-btn-resume"
      to={`/train/${course.slug}?mode=${snapshot.mode}`}
      aria-label={`Back to game: ${course.title}, move ${snapshot.moveNumber}`}
      title={`${course.title}, move ${snapshot.moveNumber}`}
    >
      <span aria-hidden="true">←</span> <span className="resume-full">Back to game</span>
      <span className="resume-short">Game</span>
    </NavLink>
  );
}
